<template>
  <div class="captcha-container">
    <a-input
        v-model:value="captchaValue"
        :placeholder="placeholder"
        style="flex: 1;"
        @change="handleChange"
    />
    <div
        @click="refreshCaptcha"
        class="captcha-image"
    >
      <img :src="captchaUrl" alt="验证码" />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'Captcha',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入验证码'
    },
    // 验证场景
    scene: {
      type: String,
      default: 'login'
    },
  },
  data() {
    return {
      captchaValue: this.value,
      captchaUrl: '',
      captchaKey: '',  // 存储验证码标识
      providerId: '',  // 存储供应商ID
    }
  },
  created() {
    this.refreshCaptcha()
  },
  methods: {
    async refreshCaptcha() {
      try {
        const response = await request.get(`/captcha/get_verify/${this.scene}`);
        console.log(response)
        if (response.code === "success" && response.data) {
          const {key, captcha_image, provider_id } = response.data;
          this.captchaKey = key;
          this.providerId = provider_id;
          // 通知父组件providerId已更新
          this.$emit('provider-id-updated', this.providerId);
          // 将字节数组转换为Base64图片
          if (captcha_image) {
            const base64Image = 'data:image/png;base64,' + captcha_image;
            this.captchaUrl = base64Image;
          }
        }
      } catch (error) {
        console.error('获取验证码失败:', error);
      }
    },
    handleChange(e) {
      this.$emit('update:value', this.captchaValue)
      this.$emit('change', this.captchaValue)
    }
  }
}
</script>

<style scoped>
.captcha-container {
  display: flex;
  gap: 10px;
}

.captcha-image {
  width: 120px;
  height: 32px;
  cursor: pointer;
}

.captcha-image img {
  width: 100%;
  height: 100%;
}
</style>
